module.exports = __webpack_public_path__ + "42e11a1afb321056726cb714fc2b29ed.svg";